import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useMessengerFactory } from "@faire/retailer-visitor-shared/stores/MessengerFactory";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Account } from "@faire/web--source/slate/icons/foundation/Account";
import { Spacer } from "@faire/web--source/slate/spacing";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { trackRetailerNotificationsUserAccountClick } from "@faire/web-api--source/events/retailerNotifications/click/userAccount";
import React, { Suspense, useState } from "react";
import { LazyHeaderAccount } from "@faire/retailer/components/Header/HeaderAccount/index";
import { HeaderClickItem } from "@faire/retailer/components/Header/HeaderClickItem";
import { IconWithMaybeDot } from "@faire/retailer/components/Header/icons/IconWithMaybeDot";
import { HeaderDropdown, HeaderIconContainer, MAX_HEADER_WIDTH } from "@faire/retailer/components/Header/styled";
import { useIsHeaderDropdownVisible } from "@faire/retailer/components/HeaderPriorityRenderer/useIsHeaderDropdownVisible";
import { useRevampedDropdownData } from "@faire/retailer/hooks/accountMenu/useRevampedDropdownData";
import { useFairePayInfo } from "@faire/retailer/hooks/fairePay/useFairePayInfo";
export var HeaderAccountDropdown = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var retailer = useRetailerStore([
        "retailer"
    ]).retailer;
    var _useState = _sliced_to_array(useState(false), 2), shouldShowDropdown = _useState[0], setShouldShowDropdown = _useState[1];
    var _useMessengerFactory = useMessengerFactory([
        "messengerStore"
    ]), unreadConversationCount = _useMessengerFactory.messengerStore.unreadConversationCount;
    var setHeaderDropdownVisibility = useIsHeaderDropdownVisible().setHeaderDropdownVisibility;
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var _useFairePayInfo = useFairePayInfo(), isPreEnrolledFairePay = _useFairePayInfo.isPreEnrolled;
    var showDot = unreadConversationCount > 0 || isPreEnrolledFairePay;
    // prefetch the data for the dropdown that is used in the child component
    useRevampedDropdownData();
    // place the dropdown at the right edge of the header
    var rightPosition = viewportWidth <= MAX_HEADER_WIDTH ? 0 : (viewportWidth - MAX_HEADER_WIDTH) / 2;
    if (retailer === undefined) {
        return null;
    }
    var toggleHandler = function(shouldShowDropdown) {
        setShouldShowDropdown(shouldShowDropdown);
        setHeaderDropdownVisibility("ACCOUNT", shouldShowDropdown);
    };
    var accountDropdown = /*#__PURE__*/ _jsx(HeaderDropdown, {
        $right: "".concat(rightPosition, "px"),
        $width: "288px",
        $maxHeight: "calc(100vh - 110px)",
        children: /*#__PURE__*/ _jsx(Suspense, {
            fallback: null,
            children: /*#__PURE__*/ _jsx(LazyHeaderAccount, {
                onItemClick: function() {
                    return setShouldShowDropdown(false);
                }
            })
        })
    });
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(HeaderClickItem, {
                clickChild: accountDropdown,
                dataTestId: "accountDropdown",
                ariaLabel: strictLocalize({
                    id: "IGnh1S",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "My Profile"
                        }
                    ]
                }),
                onClick: trackRetailerNotificationsUserAccountClick,
                toggleDropdown: toggleHandler,
                shouldShowDropdown: shouldShowDropdown,
                children: /*#__PURE__*/ _jsx(HeaderIconContainer, {
                    children: /*#__PURE__*/ _jsx(IconWithMaybeDot, {
                        icon: /*#__PURE__*/ _jsx(Account, {
                            strokeWidth: 0.8,
                            fontSize: "24px"
                        }),
                        shouldAnimateDot: true,
                        shouldShowDot: showDot,
                        isActive: shouldShowDropdown,
                        delayAnimationTime: 750,
                        dataTestId: "notification-dot"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                size: 12
            })
        ]
    });
};
